import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    padding: 15px 20px 20px 20px;
    display: flex;
    gap: 10px;
    align-items: center;
    width: 100%;
    position: relative;
    height: 79px;
`;

export const YatHand = styled(Link)`
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;

    width: 44px;
    height: 44px;

    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    transition:
        color 0.1s ease-in-out,
        box-shadow 0.1s ease-in-out,
        transform 0.1s ease-in-out;

    color: rgba(255, 255, 255, 0.5);

    svg {
        position: relative;
        top: 0;
        right: -1px;
    }

    &:hover {
        color: #fff;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }

    &:active {
        color: #fff;
    }
`;

export const Copyright = styled.div`
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: -0.6px;

    color: #878787;
    flex-grow: 1;

    white-space: nowrap;
`;

export const SidebarToggle = styled.button<{ $isMinimized?: boolean }>`
    width: 30px;
    height: 30px;

    border: none;
    cursor: pointer;

    transition: transform 0.1s ease-in-out;

    background: rgba(255, 255, 255, 0.1);
    border-radius: 100%;

    color: #fff;

    position: absolute;
    top: 22px;
    right: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
        color 0.1s ease-in-out,
        box-shadow 0.1s ease-in-out,
        transform 0.1s ease-in-out;

    &:hover {
        color: #fff;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }

    &:active {
        color: #fff;
    }

    ${({ $isMinimized }) =>
        $isMinimized &&
        css`
            right: 28px;
        `}
`;
